// Language translations — 3 languages
export const SUPPORTED_LANGUAGES = [
  { code: "bg", label: "BG", name: "Български", dir: "ltr" },
  { code: "en", label: "EN", name: "English", dir: "ltr" },
  { code: "es", label: "ES", name: "Español", dir: "ltr" },
];

export const translations = {
  en: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "Insights",
    "header.history": "History",
    "header.credits": "Points",
    "header.admin": "Admin Panel",
    "header.credits_label": "points",
    "header.logout": "Logout",
    "dashboard.complete_profile": "Complete your health profile to get personalized goals and recommendations!",
    "dashboard.complete_profile_btn": "Complete Profile",
    "dashboard.later": "Later",
    "overview.overall_score": "Overall Score",
    "overview.daily_wellness": "Your daily wellness index",
    "overview.nutrition_balance": "Nutrition Balance",
    "overview.macro_balance": "Macro balance today",
    "overview.metabolic_activity": "Metabolic Activity",
    "overview.energy_level": "Energy & activity level",
    "overview.ai_recommendations": "AI Recommendations",
    "overview.new_insights": "New insights available",
    "tracking.title": "Daily Tracking",
    "tracking.calories": "Calories",
    "tracking.protein": "Protein",
    "tracking.carbs": "Carbs",
    "tracking.fat": "Fat",
    "tracking.water": "Water",
    "tracking.sleep": "Sleep",
    "tracking.activity": "Activity",
    "ai.title": "Ask AI",
    "ai.subtitle": "Nutrition, metabolism & lifestyle",
    "ai.placeholder": "Ask about nutrition, metabolism, or your daily habits...",
    "ai.credits_per_question": "~5-8 credits per question",
    "ai.your_balance": "Your balance:",
    "ai.generating": "Generating insight...",
    "ai.personalized_insight": "AI Health Insight",
    "ai.credits_used": "points used",
    "suggestion.energy": "What foods help with sustained energy?",
    "suggestion.sleep": "How can I improve my sleep quality?",
    "suggestion.macros": "Best macros for muscle recovery",
    "insights.title": "AI Insights",
    "insights.today": "TODAY'S INSIGHT",
    "insights.today_text": "Start tracking your daily intake to receive personalized AI insights about your nutrition and metabolism.",
    "insights.optimization": "OPTIMIZATION TIP",
    "insights.optimization_text": "Ask our AI about your specific health goals - whether it's optimizing energy, improving sleep, or balancing macros.",
    "insights.action": "SUGGESTED ACTION",
    "insights.action_text": "Try asking: 'What are the best foods for sustained energy throughout the day?'",
    "history.title": "Query History",
    "history.no_queries": "No queries yet",
    "history.start_asking": "Start asking questions to build your history",
    "credits.current_balance": "Current Balance",
    "credits.buy": "Buy Points",
    "credits.how_it_works": "How points work",
    "credits.simple_question": "Simple question",
    "credits.complex_analysis": "Complex analysis",
    "credits.per_agent": "Per AI agent",
    "credits.purchase": "Purchase",
    "credits.popular": "Popular",
    "profile.title": "Edit Profile",
    "profile.personal": "Personal Information",
    "profile.body": "Body Metrics",
    "profile.lifestyle": "Lifestyle & Goals",
    "profile.save": "Save Changes",
    "profile.cancel": "Cancel",
    "profile.name": "Full Name",
    "profile.age": "Age",
    "profile.gender": "Gender",
    "profile.male": "Male",
    "profile.female": "Female",
    "profile.height": "Height (cm)",
    "profile.weight": "Weight (kg)",
    "profile.activity": "Activity Level",
    "profile.goal": "Primary Goal",
    "profile.sedentary": "Sedentary",
    "profile.light": "Lightly Active",
    "profile.moderate": "Moderately Active",
    "profile.active": "Very Active",
    "profile.very_active": "Extra Active",
    "profile.weight_loss": "Weight Loss",
    "profile.muscle_gain": "Muscle Gain",
    "profile.maintenance": "Maintain Weight",
    "profile.general_health": "General Health",
    "profile.insulin_resistance": "Insulin Resistance",
    "profile.diabetes_type2": "Type 2 Diabetes",
    "settings.language": "Language",
    "settings.theme": "Theme",
    "settings.light": "Light",
    "settings.dark": "Dark",
    "admin.title": "Patient Management",
    "admin.total_users": "Total Patients",
    "admin.with_profile": "With Profile",
    "admin.total_queries": "Total Queries",
    "admin.search": "Search patients...",
    "admin.patient_details": "Patient Details",
    "admin.metrics": "Health Metrics",
    "admin.query_history": "Query History",
    "admin.no_profile": "No profile data",
    "admin.export": "Export Data",
    "footer.disclaimer": "This platform provides informational insights only and does not replace professional medical advice, diagnosis, or treatment.",
    "footer.copyright": "© 2026 Nutramilo. All rights reserved.",
    "common.loading": "Loading...",
    "common.error": "Error",
    "common.success": "Success",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.view": "View",
  },

  bg: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "Анализи",
    "header.history": "История",
    "header.credits": "Точки",
    "header.admin": "Админ панел",
    "header.credits_label": "точки",
    "header.logout": "Изход",
    "dashboard.complete_profile": "Попълнете здравния си профил за персонализирани цели и препоръки!",
    "dashboard.complete_profile_btn": "Попълни профил",
    "dashboard.later": "По-късно",
    "overview.overall_score": "Общ резултат",
    "overview.daily_wellness": "Вашият дневен здравен показател",
    "overview.nutrition_balance": "Хранителен баланс",
    "overview.macro_balance": "Баланс на макросите днес",
    "overview.metabolic_activity": "Метаболитна активност",
    "overview.energy_level": "Енергия и активност",
    "overview.ai_recommendations": "AI препоръки",
    "overview.new_insights": "Нови препоръки",
    "tracking.title": "Дневно проследяване",
    "tracking.calories": "Калории",
    "tracking.protein": "Протеин",
    "tracking.carbs": "Въглехидрати",
    "tracking.fat": "Мазнини",
    "tracking.water": "Вода",
    "tracking.sleep": "Сън",
    "tracking.activity": "Активност",
    "ai.title": "Попитай AI",
    "ai.subtitle": "Хранене, метаболизъм и начин на живот",
    "ai.placeholder": "Попитайте за хранене, метаболизъм или дневни навици...",
    "ai.credits_per_question": "~5-8 кредита на въпрос",
    "ai.your_balance": "Вашият баланс:",
    "ai.generating": "Подготвяне на отговор...",
    "ai.personalized_insight": "AI здравен анализ",
    "ai.credits_used": "изразходвани кредити",
    "suggestion.energy": "Кои храни помагат за енергия през деня?",
    "suggestion.sleep": "Как да подобря качеството на съня?",
    "suggestion.macros": "Макроси за възстановяване на мускулите",
    "insights.title": "AI Анализи",
    "insights.today": "ДНЕШЕН АНАЛИЗ",
    "insights.today_text": "Започнете да проследявате дневния си прием, за да получавате персонализирани AI анализи.",
    "insights.optimization": "СЪВЕТ ЗА ПОДОБРЕНИЕ",
    "insights.optimization_text": "Попитайте нашия AI за вашите здравни цели - енергия, сън или баланс на макросите.",
    "insights.action": "ПРЕДЛОЖЕНО ДЕЙСТВИЕ",
    "insights.action_text": "Опитайте да попитате: 'Кои са най-добрите храни за енергия през деня?'",
    "history.title": "История на запитванията",
    "history.no_queries": "Няма запитвания",
    "history.start_asking": "Започнете да задавате въпроси",
    "credits.current_balance": "Наличен баланс",
    "credits.buy": "Купете кредити",
    "credits.how_it_works": "Как работят кредитите",
    "credits.simple_question": "Прост въпрос",
    "credits.complex_analysis": "Подробен анализ",
    "credits.per_agent": "На AI помощник",
    "credits.purchase": "Купете",
    "credits.popular": "Популярен",
    "profile.title": "Редактиране на профил",
    "profile.personal": "Лична информация",
    "profile.body": "Телесни показатели",
    "profile.lifestyle": "Начин на живот и цели",
    "profile.save": "Запази промените",
    "profile.cancel": "Отказ",
    "profile.name": "Име",
    "profile.age": "Възраст",
    "profile.gender": "Пол",
    "profile.male": "Мъж",
    "profile.female": "Жена",
    "profile.height": "Ръст (см)",
    "profile.weight": "Тегло (кг)",
    "profile.activity": "Ниво на активност",
    "profile.goal": "Основна цел",
    "profile.sedentary": "Заседнал",
    "profile.light": "Леко активен",
    "profile.moderate": "Умерено активен",
    "profile.active": "Много активен",
    "profile.very_active": "Изключително активен",
    "profile.weight_loss": "Отслабване",
    "profile.muscle_gain": "Мускулна маса",
    "profile.maintenance": "Поддържане",
    "profile.general_health": "Общо здраве",
    "profile.insulin_resistance": "Инсулинова резистентност",
    "profile.diabetes_type2": "Диабет тип 2",
    "settings.language": "Език",
    "settings.theme": "Тема",
    "settings.light": "Светла",
    "settings.dark": "Тъмна",
    "admin.title": "Управление на пациенти",
    "admin.total_users": "Общо пациенти",
    "admin.with_profile": "С профил",
    "admin.total_queries": "Общо запитвания",
    "admin.search": "Търси пациенти...",
    "admin.patient_details": "Детайли за пациента",
    "admin.metrics": "Здравни показатели",
    "admin.query_history": "История на запитванията",
    "admin.no_profile": "Няма профилни данни",
    "admin.export": "Изтегляне на данни",
    "footer.disclaimer": "Тази платформа предоставя само информационни анализи и не замества професионален медицински съвет, диагноза или лечение.",
    "footer.copyright": "© 2026 Nutramilo. Всички права запазени.",
    "common.loading": "Зареждане...",
    "common.error": "Грешка",
    "common.success": "Успех",
    "common.save": "Запази",
    "common.cancel": "Отказ",
    "common.edit": "Редактирай",
    "common.delete": "Изтрий",
    "common.view": "Преглед",
  },

  es: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "Analisis",
    "header.history": "Historial",
    "header.credits": "Puntos",
    "header.admin": "Panel de Admin",
    "header.credits_label": "puntos",
    "header.logout": "Cerrar sesion",
    "dashboard.complete_profile": "Complete su perfil de salud para obtener objetivos y recomendaciones personalizadas.",
    "dashboard.complete_profile_btn": "Completar perfil",
    "dashboard.later": "Despues",
    "overview.overall_score": "Puntuacion general",
    "overview.daily_wellness": "Su indice de bienestar diario",
    "overview.nutrition_balance": "Balance nutricional",
    "overview.macro_balance": "Balance de macros hoy",
    "overview.metabolic_activity": "Actividad metabolica",
    "overview.energy_level": "Nivel de energia y actividad",
    "overview.ai_recommendations": "Recomendaciones AI",
    "overview.new_insights": "Nuevos analisis disponibles",
    "tracking.title": "Seguimiento diario",
    "tracking.calories": "Calorias",
    "tracking.protein": "Proteina",
    "tracking.carbs": "Carbohidratos",
    "tracking.fat": "Grasa",
    "tracking.water": "Agua",
    "tracking.sleep": "Sueno",
    "tracking.activity": "Actividad",
    "ai.title": "Preguntar a AI",
    "ai.subtitle": "Nutricion, metabolismo y estilo de vida",
    "ai.placeholder": "Pregunte sobre nutricion, metabolismo o habitos diarios...",
    "ai.credits_per_question": "~5-8 puntos por pregunta",
    "ai.your_balance": "Tu saldo:",
    "ai.generating": "Generando respuesta...",
    "ai.personalized_insight": "Analisis de salud IA",
    "ai.credits_used": "puntos utilizados",
    "suggestion.energy": "Que alimentos ayudan con la energia sostenida?",
    "suggestion.sleep": "Como puedo mejorar la calidad del sueno?",
    "suggestion.macros": "Mejores macros para recuperacion muscular",
    "insights.title": "Analisis AI",
    "insights.today": "ANALISIS DE HOY",
    "insights.today_text": "Comience a registrar su ingesta diaria para recibir analisis personalizados de IA sobre su nutricion y metabolismo.",
    "insights.optimization": "CONSEJO DE OPTIMIZACION",
    "insights.optimization_text": "Pregunte a nuestra IA sobre sus objetivos de salud especificos — ya sea optimizar energia, mejorar el sueno o equilibrar macros.",
    "insights.action": "ACCION SUGERIDA",
    "insights.action_text": "Pruebe preguntar: 'Cuales son los mejores alimentos para energia sostenida durante el dia?'",
    "history.title": "Historial de consultas",
    "history.no_queries": "Sin consultas aun",
    "history.start_asking": "Comience a hacer preguntas",
    "credits.current_balance": "Saldo actual",
    "credits.buy": "Comprar puntos",
    "credits.how_it_works": "Como funcionan los puntos",
    "credits.simple_question": "Pregunta simple",
    "credits.complex_analysis": "Analisis complejo",
    "credits.per_agent": "Por agente IA",
    "credits.purchase": "Comprar",
    "credits.popular": "Popular",
    "profile.title": "Editar perfil",
    "profile.personal": "Informacion personal",
    "profile.body": "Metricas corporales",
    "profile.lifestyle": "Estilo de vida y objetivos",
    "profile.save": "Guardar cambios",
    "profile.cancel": "Cancelar",
    "profile.name": "Nombre completo",
    "profile.age": "Edad",
    "profile.gender": "Genero",
    "profile.male": "Masculino",
    "profile.female": "Femenino",
    "profile.height": "Altura (cm)",
    "profile.weight": "Peso (kg)",
    "profile.activity": "Nivel de actividad",
    "profile.goal": "Objetivo principal",
    "profile.sedentary": "Sedentario",
    "profile.light": "Ligeramente activo",
    "profile.moderate": "Moderadamente activo",
    "profile.active": "Muy activo",
    "profile.very_active": "Extra activo",
    "profile.weight_loss": "Perdida de peso",
    "profile.muscle_gain": "Ganancia muscular",
    "profile.maintenance": "Mantener peso",
    "profile.general_health": "Salud general",
    "profile.insulin_resistance": "Resistencia a la insulina",
    "profile.diabetes_type2": "Diabetes tipo 2",
    "settings.language": "Idioma",
    "settings.theme": "Tema",
    "settings.light": "Claro",
    "settings.dark": "Oscuro",
    "admin.title": "Gestion de pacientes",
    "admin.total_users": "Total pacientes",
    "admin.with_profile": "Con perfil",
    "admin.total_queries": "Total consultas",
    "admin.search": "Buscar pacientes...",
    "admin.patient_details": "Detalles del paciente",
    "admin.metrics": "Metricas de salud",
    "admin.query_history": "Historial de consultas",
    "admin.no_profile": "Sin datos de perfil",
    "admin.export": "Exportar datos",
    "footer.disclaimer": "Esta plataforma solo proporciona informacion y no reemplaza el consejo medico profesional.",
    "footer.copyright": "© 2026 Nutramilo. Todos los derechos reservados.",
    "common.loading": "Cargando...",
    "common.error": "Error",
    "common.success": "Exito",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.view": "Ver",
  },

  de: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "Analysen",
    "header.history": "Verlauf",
    "header.credits": "Punkte",
    "header.admin": "Admin-Panel",
    "header.credits_label": "Punkte",
    "header.logout": "Abmelden",
    "dashboard.complete_profile": "Vervollstandigen Sie Ihr Gesundheitsprofil fur personalisierte Ziele und Empfehlungen!",
    "dashboard.complete_profile_btn": "Profil vervollstandigen",
    "dashboard.later": "Spater",
    "overview.overall_score": "Gesamtbewertung",
    "overview.daily_wellness": "Ihr taglicher Wellness-Index",
    "overview.nutrition_balance": "Ernahrungsbalance",
    "overview.macro_balance": "Makro-Balance heute",
    "overview.metabolic_activity": "Stoffwechselaktivitat",
    "overview.energy_level": "Energie- und Aktivitatsniveau",
    "overview.ai_recommendations": "AI-Empfehlungen",
    "overview.new_insights": "Neue Analysen verfugbar",
    "tracking.title": "Tagliches Tracking",
    "tracking.calories": "Kalorien",
    "tracking.protein": "Protein",
    "tracking.carbs": "Kohlenhydrate",
    "tracking.fat": "Fett",
    "tracking.water": "Wasser",
    "tracking.sleep": "Schlaf",
    "tracking.activity": "Aktivitat",
    "ai.title": "AI fragen",
    "ai.subtitle": "Ernahrung, Stoffwechsel und Lebensstil",
    "ai.placeholder": "Fragen Sie uber Ernahrung, Stoffwechsel oder tagliche Gewohnheiten...",
    "ai.generating": "Antwort wird generiert...",
    "ai.personalized_insight": "AI Gesundheitsanalyse",
    "suggestion.energy": "Welche Lebensmittel helfen bei nachhaltiger Energie?",
    "suggestion.sleep": "Wie kann ich meine Schlafqualitat verbessern?",
    "suggestion.macros": "Beste Makros fur Muskelregeneration",
    "insights.title": "AI-Analysen",
    "history.title": "Anfrageverlauf",
    "history.no_queries": "Noch keine Anfragen",
    "history.start_asking": "Stellen Sie Fragen",
    "profile.title": "Profil bearbeiten",
    "profile.personal": "Personliche Informationen",
    "profile.body": "Korpermetriken",
    "profile.lifestyle": "Lebensstil und Ziele",
    "profile.save": "Anderungen speichern",
    "profile.cancel": "Abbrechen",
    "profile.name": "Vollstandiger Name",
    "profile.age": "Alter",
    "profile.gender": "Geschlecht",
    "profile.male": "Mannlich",
    "profile.female": "Weiblich",
    "profile.height": "Grosse (cm)",
    "profile.weight": "Gewicht (kg)",
    "settings.language": "Sprache",
    "settings.theme": "Design",
    "admin.title": "Patientenverwaltung",
    "admin.search": "Patienten suchen...",
    "admin.patient_details": "Patientendetails",
    "admin.no_profile": "Keine Profildaten",
    "admin.export": "Daten exportieren",
    "footer.disclaimer": "Diese Plattform bietet nur informative Analysen und ersetzt keine professionelle medizinische Beratung.",
    "footer.copyright": "© 2026 Nutramilo. Alle Rechte vorbehalten.",
    "common.loading": "Laden...",
    "common.error": "Fehler",
    "common.success": "Erfolg",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
  },

  ar: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "تحليلات",
    "header.history": "السجل",
    "header.credits": "نقاط",
    "header.admin": "لوحة الادارة",
    "header.credits_label": "نقاط",
    "header.logout": "تسجيل الخروج",
    "dashboard.complete_profile": "اكمل ملفك الصحي للحصول على اهداف وتوصيات مخصصة!",
    "dashboard.complete_profile_btn": "اكمال الملف",
    "dashboard.later": "لاحقا",
    "overview.overall_score": "النتيجة الاجمالية",
    "overview.daily_wellness": "مؤشر العافية اليومي",
    "overview.nutrition_balance": "التوازن الغذائي",
    "overview.macro_balance": "توازن المغذيات الكبرى اليوم",
    "overview.metabolic_activity": "النشاط الايضي",
    "overview.energy_level": "مستوى الطاقة والنشاط",
    "overview.ai_recommendations": "توصيات الذكاء الاصطناعي",
    "overview.new_insights": "تحليلات جديدة متاحة",
    "tracking.title": "التتبع اليومي",
    "tracking.calories": "السعرات",
    "tracking.protein": "البروتين",
    "tracking.carbs": "الكربوهيدرات",
    "tracking.fat": "الدهون",
    "tracking.water": "الماء",
    "tracking.sleep": "النوم",
    "tracking.activity": "النشاط",
    "ai.title": "اسال الذكاء الاصطناعي",
    "ai.subtitle": "التغذية والايض ونمط الحياة",
    "ai.placeholder": "اسال عن التغذية او الايض او العادات اليومية...",
    "ai.generating": "جاري التحليل...",
    "ai.personalized_insight": "افعل هذا اليوم",
    "suggestion.energy": "ما الاطعمة التي تساعد في الطاقة المستدامة؟",
    "suggestion.sleep": "كيف يمكنني تحسين جودة النوم؟",
    "suggestion.macros": "افضل المغذيات الكبرى لاستعادة العضلات",
    "insights.title": "تحليلات الذكاء الاصطناعي",
    "history.title": "سجل الاستفسارات",
    "history.no_queries": "لا توجد استفسارات",
    "history.start_asking": "ابدا بطرح الاسئلة",
    "profile.title": "تعديل الملف الشخصي",
    "profile.personal": "المعلومات الشخصية",
    "profile.body": "مقاييس الجسم",
    "profile.lifestyle": "نمط الحياة والاهداف",
    "profile.save": "حفظ التغييرات",
    "profile.cancel": "الغاء",
    "profile.name": "الاسم الكامل",
    "profile.age": "العمر",
    "profile.gender": "الجنس",
    "profile.male": "ذكر",
    "profile.female": "انثى",
    "profile.height": "الطول (سم)",
    "profile.weight": "الوزن (كجم)",
    "settings.language": "اللغة",
    "settings.theme": "المظهر",
    "admin.title": "ادارة المرضى",
    "admin.search": "بحث عن مرضى...",
    "admin.patient_details": "تفاصيل المريض",
    "admin.no_profile": "لا توجد بيانات",
    "admin.export": "تصدير البيانات",
    "footer.disclaimer": "هذه المنصة تقدم معلومات فقط ولا تحل محل الاستشارة الطبية المهنية.",
    "footer.copyright": "© 2026 Nutramilo. جميع الحقوق محفوظة.",
    "common.loading": "جاري التحميل...",
    "common.error": "خطا",
    "common.success": "نجاح",
    "common.save": "حفظ",
    "common.cancel": "الغاء",
  },

  zh: {
    "app.name": "Nutramilo",
    "app.subtitle": "Health OS",
    "header.insights": "分析",
    "header.history": "历史",
    "header.credits": "积分",
    "header.admin": "管理面板",
    "header.credits_label": "积分",
    "header.logout": "退出登录",
    "dashboard.complete_profile": "完善您的健康档案以获取个性化目标和建议！",
    "dashboard.complete_profile_btn": "完善档案",
    "dashboard.later": "稍后",
    "overview.overall_score": "综合评分",
    "overview.daily_wellness": "每日健康指数",
    "overview.nutrition_balance": "营养平衡",
    "overview.macro_balance": "今日宏量营养素平衡",
    "overview.metabolic_activity": "代谢活动",
    "overview.energy_level": "能量和活动水平",
    "overview.ai_recommendations": "AI建议",
    "overview.new_insights": "新分析可用",
    "tracking.title": "每日追踪",
    "tracking.calories": "卡路里",
    "tracking.protein": "蛋白质",
    "tracking.carbs": "碳水化合物",
    "tracking.fat": "脂肪",
    "tracking.water": "水",
    "tracking.sleep": "睡眠",
    "tracking.activity": "活动",
    "ai.title": "询问AI",
    "ai.subtitle": "营养、代谢与生活方式",
    "ai.placeholder": "询问有关营养、代谢或日常习惯的问题...",
    "ai.generating": "正在生成回答...",
    "ai.personalized_insight": "今日建议",
    "suggestion.energy": "哪些食物有助于持久能量？",
    "suggestion.sleep": "如何改善睡眠质量？",
    "suggestion.macros": "最佳肌肉恢复宏量营养素",
    "insights.title": "AI分析",
    "history.title": "查询历史",
    "history.no_queries": "暂无查询",
    "history.start_asking": "开始提问",
    "profile.title": "编辑个人资料",
    "profile.personal": "个人信息",
    "profile.body": "身体指标",
    "profile.lifestyle": "生活方式与目标",
    "profile.save": "保存更改",
    "profile.cancel": "取消",
    "profile.name": "姓名",
    "profile.age": "年龄",
    "profile.gender": "性别",
    "profile.male": "男",
    "profile.female": "女",
    "profile.height": "身高 (cm)",
    "profile.weight": "体重 (kg)",
    "settings.language": "语言",
    "settings.theme": "主题",
    "admin.title": "患者管理",
    "admin.search": "搜索患者...",
    "admin.patient_details": "患者详情",
    "admin.no_profile": "无档案数据",
    "admin.export": "导出数据",
    "footer.disclaimer": "本平台仅提供信息分析，不替代专业医疗建议、诊断或治疗。",
    "footer.copyright": "© 2026 Nutramilo. 保留所有权利。",
    "common.loading": "加载中...",
    "common.error": "错误",
    "common.success": "成功",
    "common.save": "保存",
    "common.cancel": "取消",
  },
};

export const getTranslation = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations['en']?.[key] || key;
};
